import { publicApiHeaders } from './publicApiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

function getSessionId() {
  const key = 'cd_engagement_session';
  let sessionId = sessionStorage.getItem(key);

  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(key, sessionId);
  }

  return sessionId;
}

export function trackEngagement(contentType, eventType, metadata = {}) {
  const eventValue = metadata.contentId
    ? `${eventType}:${metadata.contentId}`
    : eventType;

  const payload = {
    contentType,
    eventType: eventValue.slice(0, 50),
    sessionId: getSessionId(),
  };

  return fetch(`${API_BASE_URL}/content/engagement`, {
    method: 'POST',
    headers: { ...publicApiHeaders, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => undefined);
}
